import { BrandPlan, BrandPlanIntegrations, BrandPlanTactic } from 'types'
import { getTacticsFromContentCounts } from 'screens/BrandKits/components/BrandPlan/utils'

export const normalizeTactic = (tactic: BrandPlanIntegrations): BrandPlanIntegrations => {
  return tactic === BrandPlanTactic.InstagramReel ? BrandPlanTactic.Instagram : tactic
}

// InstagramReel is normalized to Instagram since they map to the same integration.
export const getNormalizedTactics = (brandPlan: BrandPlan | null | undefined): BrandPlanIntegrations[] => {
  if (!brandPlan) {
    return []
  }

  // In crosspost mode, tactics are stored per content item and skipped by getTacticsFromContentCounts.
  const fromCrosspost = (items?: { tactics?: BrandPlanTactic[] }[]) =>
    items?.flatMap((item) => item.tactics ?? []) ?? []

  const fromContentStrategies = (strategies: BrandPlan['content_strategies']) =>
    Object.values(strategies ?? {}).flatMap((strategy) => strategy?.tactics ?? [])

  const normalizedTactics = [
    ...brandPlan.tactics,
    ...getTacticsFromContentCounts(brandPlan),
    ...fromCrosspost(brandPlan.crosspost_contents),
    ...fromCrosspost(brandPlan.video_crosspost_contents),
    ...fromContentStrategies(brandPlan.content_strategies),
  ].map((tactic) => normalizeTactic(tactic))

  return Array.from(new Set(normalizedTactics))
}
